import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, MapPin, ShieldCheck, Users, Star, Send } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-179">
      {/* Background with Gradient Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-180">
        <div className="absolute inset-0 bg-gradient-to-b from-cream via-cream/50 to-cream z-10" data-id="element-181" />
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-20" data-id="element-182" />

        {/* Decorative Elements */}
        <motion.div animate={{
        y: [0, -20, 0],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/4 left-10 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-183" />
        <motion.div animate={{
        y: [0, 30, 0],
        opacity: [0.2, 0.5, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-1/4 right-10 w-80 h-80 bg-forest/10 rounded-full blur-3xl" data-id="element-184" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-186">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/10 text-gold-dark text-sm font-medium mb-6 border border-gold/20" data-id="element-187">
            Singapore's #1 Premium Spa Guide
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-forest mb-4 leading-tight" data-id="element-188">
            Discover Singapore's Finest <br data-id="element-189" />
            <span className="text-gold italic" data-id="element-190">Massage Experiences</span>
          </h1>
          <p className="text-xl md:text-2xl text-stone/80 mb-10 font-light tracking-wide" data-id="element-191">
            新加坡最值得信赖的专业按摩推荐平台
          </p>
        </motion.div>

        {/* Website Enter & Telegram Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl mx-auto mb-16 flex flex-col sm:flex-row gap-4" data-id="element-192">
          <a href="https://geylang777-6.site/" target="_blank" rel="noopener noreferrer" className="group flex-1 block bg-white p-5 rounded-2xl shadow-xl shadow-stone/10 border border-stone/5 hover:border-gold/30 hover:shadow-gold/10 transition-all duration-300" data-id="element-193">
            <div className="flex items-center gap-4" data-id="element-194">
              <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center shrink-0 group-hover:bg-gold/20 transition-colors" data-id="element-195">
                <ExternalLink className="text-gold" size={24} data-id="element-196" />
              </div>
              <div className="text-left" data-id="element-197">
                <span className="block text-forest font-serif font-bold text-lg group-hover:text-gold transition-colors" data-id="element-198">
                  Website Enter
                </span>
                <span className="block text-stone/70 text-sm" data-id="element-199">
                  中文网站入口
                </span>
              </div>
              <div className="ml-auto bg-forest group-hover:bg-gold text-white px-4 py-2.5 rounded-xl font-medium transition-colors duration-300 text-sm whitespace-nowrap" data-id="element-200">
                进入 →
              </div>
            </div>
          </a>

          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="group flex-1 block bg-white p-5 rounded-2xl shadow-xl shadow-stone/10 border border-stone/5 hover:border-emerald-500/30 hover:shadow-emerald-500/10 transition-all duration-300" data-id="element-201">
            <div className="flex items-center gap-4" data-id="element-202">
              <div className="w-12 h-12 bg-emerald-500/10 rounded-full flex items-center justify-center shrink-0 group-hover:bg-emerald-500/20 transition-colors" data-id="element-203">
                <ExternalLink className="text-emerald-600" size={24} data-id="element-204" />
              </div>
              <div className="text-left" data-id="element-205">
                <span className="block text-forest font-serif font-bold text-lg group-hover:text-emerald-600 transition-colors" data-id="element-206">
                  新加坡春风阁
                </span>
                <span className="block text-stone/70 text-sm" data-id="element-207">春风阁入口</span>
              </div>
              <div className="ml-auto bg-emerald-600 group-hover:bg-emerald-700 text-white px-4 py-2.5 rounded-xl font-medium transition-colors duration-300 text-sm whitespace-nowrap" data-id="element-208">
                进入 →
              </div>
            </div>
          </a>

          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="group flex-1 block bg-white p-5 rounded-2xl shadow-xl shadow-stone/10 border border-stone/5 hover:border-[#229ED9]/30 hover:shadow-[#229ED9]/10 transition-all duration-300" data-id="element-209">
            <div className="flex items-center gap-4" data-id="element-210">
              <div className="w-12 h-12 bg-[#229ED9]/10 rounded-full flex items-center justify-center shrink-0 group-hover:bg-[#229ED9]/20 transition-colors" data-id="element-211">
                <Send className="text-[#229ED9]" size={24} data-id="element-212" />
              </div>
              <div className="text-left" data-id="element-213">
                <span className="block text-forest font-serif font-bold text-lg group-hover:text-[#229ED9] transition-colors" data-id="element-214">
                  Telegram
                </span>
                <span className="block text-stone/70 text-sm" data-id="element-215">电报频道</span>
              </div>
              <div className="ml-auto bg-[#229ED9] group-hover:bg-[#1a8abf] text-white px-4 py-2.5 rounded-xl font-medium transition-colors duration-300 text-sm whitespace-nowrap" data-id="element-216">
                加入 →
              </div>
            </div>
          </a>
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto border-t border-stone/10 pt-10" data-id="element-217">
          {[{
          icon: ShieldCheck,
          label: '100% Safe & Trusted',
          sub: 'Verified Partners'
        }, {
          icon: Users,
          label: '50,000+ Customers',
          sub: 'Happy Clients'
        }, {
          icon: Star,
          label: '8+ Years',
          sub: 'Excellence'
        }, {
          icon: MapPin,
          label: '500+ Shops',
          sub: 'Islandwide'
        }].map((item, index) => <div key={index} className="flex flex-col items-center" data-id="element-218">
              <item.icon className="text-gold mb-2" size={24} data-id="element-219" />
              <span className="font-serif font-bold text-forest text-lg" data-id="element-220">
                {item.label}
              </span>
              <span className="text-xs text-stone uppercase tracking-wider" data-id="element-221">
                {item.sub}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}